<template>
  <div class="questionItem">
    <div v-html="detailData.questionContent"></div>
    <div
      v-if="$route.query.showQuestionType == 'answer'"
      v-html="detailData.questionAnswer"
    ></div>
    <div
      v-if="$route.query.showQuestionType == 'analysis'"
      v-html="detailData.analysis"
    ></div>
  </div>
</template>

<script>
import { getquestionanswer, getcorrectdetails } from "@/api/interface";
export default {
  name: "QuestionItem",
  data() {
    return {
      detailData: {},
    };
  },
  created() {
    this.getPhoneType();
  },
  mounted() {
    let type = this.$route.query.isWeb;
    if (type) {
      if (this.$route.query.token) {
        this.$store.commit("setToken", this.$route.query.token);
        this.$store.commit("setSchoolId", this.$route.query.schoolID);
      }
      this.init();
    } else {
      if (this.$route.query.token && this.$route.query.schoolID) {
        this.$store.commit("setToken", this.$route.query.token);
        this.$store.commit("setSchoolId", this.$route.query.schoolID);
        this.init();
      } else {
        window.initView = this.initView;
        this.initMobile();
      }
    }
    window.MathJax.typesetPromise();
  },
  updated() {
    window.MathJax.startup.defaultReady();
  },
  methods: {
    initMobile() {
      if (this.isiOS) {
        window.webkit.messageHandlers.commonCall.postMessage({
          type: 2,
        });
      } else {
        window.mobile.initMobile();
      }
    },
    getPhoneType() {
      let u = navigator.userAgent;
      this.isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    },
    initView(data) {
      this.apiData = data;
      this.$store.commit("setToken", data.token);
      this.$store.commit("setSchoolId", data.schoolID);
      this.init();
      // this.downWindow();
    },
    init() {
      let data = {
        id: this.$route.query.questionId,
        questionOrder: this.$route.query.questionOrder,
      };
      if (this.$route.query.studentID) {
        data.studentId = this.$route.query.studentID;
        getcorrectdetails(data).then((res) => {
          this.detailData = res.data;
        });
      } else {
        getquestionanswer(data).then((res) => {
          this.detailData = res.data;
          // console.log(res);
        });
      }
    },
  },
};
</script>
<style lang="scss">
.questionItem {
  img {
    max-width: 100%;
    height: auto !important;
  }
}
</style>
